import Footer from 'views/molecules/footer/Footer';

export default Footer;
